import styles from './AccountLimits.module.scss';
import { withStyles, formattedCurrency, AccountLimitsRail } from 'vopay';
import ProgressGraph from '../../components/ProgressGraph';
import { BodyText, Title } from 'UI';

const cn = withStyles(styles);

export type Direction = keyof AccountLimitsRail;

type AccountLimitProps = {
  type: Direction;
  title: string;
  remainingAmount: string;
  startingAmount: string;
  remaining: string;
  total: string;
  currency: string;
  strokeColor: string;
  // Shown when the limit is used up; the remaining amount then reads 0 instead of a negative overage.
  limitReachedText?: string;
};

export default function AccountLimit({
  type,
  title,
  remainingAmount,
  startingAmount,
  remaining,
  total,
  currency,
  strokeColor,
  limitReachedText,
}: AccountLimitProps) {
  return (
    <div className={cn('accountLimitsColumn')} data-testid={`account-limit-${type}`}>
      <Title level="6" emphasized={false} style={{ color: 'rgba(45, 45, 45, 0.50)' }}>
        {title}
      </Title>

      <div className={cn('graph')}>
        <ProgressGraph
          remaining={+remaining}
          total={+total}
          pathStrokeColor={strokeColor}
          trailStrokeColor={`${strokeColor}1A`}
          width="180px"
          height="180px"
        />
      </div>

      <div>
        <Title level="6" emphasized={false} style={{ color: 'rgba(45, 45, 45, 0.50)', fontSize: '13px' }}>
          {remainingAmount}
        </Title>

        <span>
          <Title level="6" emphasized={false}>
            {currency}
          </Title>

          <Title level="4">{formattedCurrency(limitReachedText ? '0' : remaining)}</Title>
        </span>

        {limitReachedText && (
          <BodyText size="sm" className={cn('limitReached')}>
            {limitReachedText}
          </BodyText>
        )}
      </div>

      <div>
        <Title level="6" emphasized={false} style={{ color: 'rgba(45, 45, 45, 0.50)', fontSize: '13px' }}>
          {startingAmount}
        </Title>

        <span>
          <Title level="6" emphasized={false}>
            {currency}
          </Title>

          <Title level="6" style={{ fontWeight: 600 }}>
            {formattedCurrency(total)}
          </Title>
        </span>
      </div>
    </div>
  );
}
